// import StandardIcon from "../images/standard-icon.svg"
// import StandardBlogginIcon from "../images/standard-blogging-icon.svg"
// import LogosBranding from "../images/logos-branding-icon.svg"

export const PACKAGES: { [key: string]: any } = {
  STANDARD: {
    title: "Standard",
    price: 150,
    features: [
      "5 Pages",
      "Unlimited Edits",
      "Includes Hosting",
      "24/7 Customer Service",
      "Lifetime Updates",
    ],
    // icon: StandardIcon,
    alt: "House Icon",
    isMonthly: true,
  },
  STANDARD_BLOGGING: {
    title: "Standard & Blogging",
    price: 275,
    features: [
      "1000 Word Post",
      "Keyword Analysis",
      "Written By an SEO Specialist",
      "Boost SEO",
    ],
    // icon: StandardBlogginIcon,
    alt: "Building Icon",
    isMonthly: true,
  },
  LOGOS_BRANDING: {
    title: "Logos & Branding",
    price: 350,
    features: [
      "2 revisions",
      "All File Formats",
      "Light & Dark Versions",
      "Horizontal & Verticle",
    ],
    // icon: LogosBranding,
    alt: "Women looking at images of houses.",
    isMonthly: false,
  },
}
